export default __webpack_public_path__ + "static/media/Sewer King's Regalia.c65c14c9.jpg";